<script setup lang="ts">
import type { BasicPropsType, ResponsivePropsType } from '@/components/goat/form/compositions/FieldsUtils'
import { BasicPropsDefaults, getFieldModel, ResponsivePropsDefaults } from '@/components/goat/form/compositions/FieldsUtils'

withDefaults(defineProps<BasicPropsType & ResponsivePropsType>(), { ...BasicPropsDefaults, ...ResponsivePropsDefaults })
defineEmits(['input'])
</script>

<template>
  <goat-form-field-wrapper v-bind="$props">
    <template #default="{ form }">
      <el-input
        v-model.trim="getFieldModel(form, apiFieldName).value"
        v-bind="$attrs"
        :placeholder="placeholder"
        @input="$emit('input', $event)"
      />
    </template>
  </goat-form-field-wrapper>
</template>

<style scoped lang="postcss">

</style>
